import React from 'react';
import { DataTable, Panel, type DataTableColumn } from '../../../../ui-kit';
import type { LookupRuleGroup } from '../../../../types/lookupDashboard';

interface RulesPanelProps {
  groups: LookupRuleGroup[];
}

type RuleRow = LookupRuleGroup['rows'][number];

const columns: DataTableColumn<RuleRow>[] = [
  { key: 'rule', header: 'Rule', name: 'Rule', fixed: true, width: 280, wrap: true, render: (r) => r.rule },
  { key: 'means', header: 'What it means', name: 'What it means', wrap: true, minWidth: 320, render: (r) => r.means },
];

/**
 * What the board's terms mean, in plain words: one table, each rule beside
 * what it means, a group per part when there is more than one. Written in the spec
 * (`rules`), so the words travel with the query they describe.
 */
export default function RulesPanel({ groups }: RulesPanelProps) {
  const table = (fill: boolean) => (
    <DataTable
      ariaLabel={groups.length === 1 ? groups[0].title : 'How this page is worked out'}
      columns={columns}
      // One group needs no heading of its own: the panel's title names it.
      groups={groups.map((g) => ({ key: g.title, title: groups.length > 1 ? g.title : '', rows: g.rows }))}
      getRowKey={(r) => r.rule}
      collapsibleGroups={false}
      fill={fill}
    />
  );
  return (
    <Panel
      title={groups.length === 1 ? groups[0].title : 'How this page is worked out'}
      flush
      expanded={{ content: table(true) }}
    >
      {table(false)}
    </Panel>
  );
}
